export default __webpack_public_path__ + "static/media/1092dcb20b186e47c1ec220204b346e51581077721580.1fbefda2.webp";